var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1196_14271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0531 16.1408C24.8107 15.4591 24.3635 14.8689 23.7728 14.4511C23.1821 14.0333 22.4767 13.8083 21.7531 13.8068H19.0441C18.2713 13.8027 17.5244 14.0854 16.9479 14.6001C16.3713 15.1149 16.0062 15.8251 15.9229 16.5935C15.8397 17.3618 16.0444 18.1338 16.4973 18.76C16.9503 19.3862 17.6193 19.8223 18.3751 19.9838L22.5001 20.8838C23.3436 21.0684 24.0891 21.5583 24.5933 22.2592C25.0976 22.96 25.3251 23.8226 25.232 24.681C25.139 25.5394 24.7321 26.3331 24.0894 26.9097C23.4467 27.4863 22.6136 27.8051 21.7501 27.8048H19.4191C17.8951 27.8048 16.5991 26.8328 16.1191 25.4738M20.5861 13.8068V10.3058M20.5861 31.3058V27.8078M5.99414 40.7168V33.2168H13.4941",
    stroke: "#006EC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1643 17.6318C40.9607 21.8774 40.3248 26.2673 38.3565 30.1125C36.3882 33.9577 33.1988 37.0404 29.2889 38.8769C25.3791 40.7134 20.9701 41.1997 16.754 40.2594C12.5378 39.3192 8.75328 37.0056 5.99427 33.6818M1.83627 24.8078C1.03985 20.5621 1.6757 16.1722 3.64404 12.3271C5.61237 8.48188 8.80177 5.39911 12.7116 3.56261C16.6215 1.72611 21.0305 1.23984 25.2466 2.18011C29.4627 3.12039 33.2473 5.43399 36.0063 8.75778",
    stroke: "#006EC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0059 1.72583V9.22583H28.5059",
    stroke: "#006EC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1196_14271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.219727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures17);
export default __webpack_public_path__ + "static/media/features17.6998af1bd2d79c498a999367bc771057.svg";
export { ForwardRef as ReactComponent };